import React, { Component } from 'react';
import {connect } from 'react-redux';
import {Link} from "react-router-dom";
import {getMainData,addUser,restUser,getmyData2} from "../../Redux/ducks/mainReducer";
import {Alert,Label,Row,Col,FormGroup,Input, Button,SpinnerModal,
    ModalBody, ModalFooter,Modal,} from 'reactstrap'
import MultiSelect from "@kenshooui/react-multi-select";
import { getName } from '../../GeneralFunctions/general';
import ReactJsAlert from "reactjs-alert"

import 'react-phone-input-2/lib/style.css'
export class Dashboard extends Component {
    state={
        isSaving:false,
        isLoading:true,
        mainData:null,
        msg:null,
        modal: JSON.parse(window.localStorage.getItem('showWelcomeAlert'))
    }

    closeAlert =()=>{
        this.setState({
            alertOpen:false
        
        })
      }
      closeModal = ()=>{
          window.localStorage.setItem('showWelcomeAlert',false);
          window.location.reload();
      }


    componentDidMount() {
       
    }
        
    componentDidUpdate(prevProps){
        const{mainData,msg,mainDataStatus,addUserStatus,getData2Status,getData2} = this.props;
        const{goNext} = this.state;
        if(mainDataStatus !== prevProps.mainDataStatus){
            if(mainDataStatus===true){
                this.setState({isSaving:false,mainData:mainData,applicationFee:mainData.applicationFee})
                const gamesData =  mainData.gamesData
                if(gamesData.length>0){
                    let gamesDataList = [];
                    gamesData.map((values,i) =>{
                        gamesDataList.push({id: values.id, label: values.name})
                    })
                    this.setState({gamesData:gamesDataList})
                }

                const clubsData =  mainData.clubsData
                if(clubsData.length>0){
                    let clubsDataList = [];
                    clubsData.map((values,i) =>{
                        clubsDataList.push({id: values.id, label: values.name})
                    })
                    this.setState({clubsData:clubsDataList})
                }
            }
        } 

        if(getData2Status !== prevProps.getData2Status){
            if(getData2Status===true){
                let selectedSubjects = []
                let bestSubjects = []
                let clubs = []
                let games = []

                const currentSubject = getData2.currentSubject !==null?getData2.currentSubject.split(',').map(Number):[]
                const bSubject = getData2.best_subjects !==null?getData2.best_subjects.split(',').map(Number):[]
                const sClubs = getData2.clubs !==null?getData2.clubs.split(',').map(Number):[]
                const sGames = getData2.game1 !==null?getData2.game1.split(',').map(Number):[]


                this.setState({applicationData:getData2,
                    applicationStatus:getData2.applicationStatus,status:getData2.status,isLoading:false,

                    serialNo:getData2.indexNo,surname:getData2.surname,firstname:getData2.firstname,othername:getData2.othername,gender:getData2.gender,dob:getData2.dob,religion:getData2.religion,level:getData2.levelID,sclass:getData2.currentClass,nationality:getData2.nationality,aggr:getData2.ple_uce_aggr,school:getData2.ple_uce_school,grade:getData2.ple_uce_grade,
                    communion:getData2.first_communion,mugigi:getData2.mugigi,confirmation:getData2.confirmation,guardian:getData2.orphan_guardian_info,f_name:getData2.f_name,f_dob:getData2.f_phone,f_nationality:getData2.f_nationality,f_dis:getData2.f_district,f_county:getData2.f_county,f_scounty:getData2.f_subcounty,f_village:getData2.f_village,f_occup:getData2.f_occupation,f_job:getData2.f_jobPost,f_work:getData2.f_placeOfWork,
                    f_postal:getData2.f_postAddress,f_phone:getData2.f_phone,f_email:getData2.f_email,m_name:getData2.m_name,m_dob:getData2.m_dob,m_nationality:getData2.m_nationality,m_dis:getData2.m_district,m_county:getData2.m_county,m_scounty:getData2.m_subcounty,m_village:getData2.m_village,m_occup:getData2.m_occupation,m_job:getData2.m_jobPost,m_work:getData2.m_placeOfWork,m_postal:getData2.m_postAddress,m_phone:getData2.m_phone,
                    m_email:getData2.m_email,sibNo:getData2.sibling_number,birthOrder:getData2.family_position,sib1:getData2.sibling_1,work1:getData2.work1,sib2:getData2.sibling_2,work2:getData2.work2,sib3:getData2.sibling_3,work3:getData2.work3,sib4:getData2.sibling_4,work4:getData2.work4,sib5:getData2.sibling_5,work5:getData2.work5,fees:getData2.whoPays_fee,sponsor:getData2.sponsor_info,bursary:getData2.bursary,handicaps:getData2.physical_handicaps,disease:getData2.chronic_disease,
                    allergy:getData2.allergies,food:getData2.do_not_eat,problems:getData2.personal_problems,jobs:getData2.jobs,leader:getData2.leader,photoName:getData2.image,nin:getData2.nin,orphan:getData2.orphan,photo2Name:getData2.image2,m_nin:getData2.m_nin,f_nin:getData2.f_nin,lin:getData2.lin,
                    selectedSubjects:selectedSubjects,games:games,clubs:clubs,bestSubjects:bestSubjects,house:getData2.house
                })

                if(parseInt(getData2.saveStatus)===1){
                    this.setState({ step1:false,step2:true,step3:false})
                }
                if(parseInt(getData2.saveStatus)===2){
                    this.setState({ step1:false,step2:false,step3:true})
                }

                if(mainData !==null){
                    if(mainData.subjectData !==null){
                        mainData.subjectData.map((values) =>{
                            if (currentSubject.includes(parseInt(values.id))) {
                                selectedSubjects.push({id: values.id, label: values.name})
                            }
                
                        })
                    }
    
                   
                    if(mainData.subjectData !==null){
                        mainData.subjectData.map((values) =>{
                            if (bSubject.includes(parseInt(values.id))) {
                                bestSubjects.push({id: values.id, label: values.name})
                            }
                        })
                    }
    
                  
                    if(mainData.clubsData !==null){
                        mainData.clubsData.map((values) =>{
                            if (sClubs.includes(parseInt(values.id))) {
                                clubs.push({id: values.id, label: values.name})
                            }
                        })
                    }
    
                   
                    if(mainData.gamesData !==null){
                        mainData.gamesData.map((values) =>{
                            if (sGames.includes(parseInt(values.id))) {
                                games.push({id: values.id, label: values.name})
                            }
                        })
                    }

                    //for setting subjects
                    const mySubData =  mainData.subjectData
                    //loop through the array
                    if(mySubData.length>0){
                        let subDataList = [];
                        mySubData.map((values,i) =>{
                            if(parseInt(getData2.levelID) ===3){
                                subDataList.push({id: values.id, label: values.name})
                            }else if(parseInt(getData2.levelID) ===parseInt(values.level)){
                                subDataList.push(
                                    {/*<option key={i} value={values.id}>{values.name}</option>*/
                                    id: values.id, label: values.name}
                                )
                            }
                        })
                        this.setState({subData:subDataList})
                    }
    
                    //for setting class
                    const myClassData =  mainData.classData
                    //loop through the array
                    if(myClassData.length>0){
                        let classDataList = [];
                        myClassData.map((values,i) =>{
                            if(parseInt(getData2.levelID) ===parseInt(values.level_id)){
                                if(parseInt(values.id) ===4 || parseInt(values.id) ===6){
                                }else{
                                    classDataList.push(
                                        <option key={i} value={values.id}>{values.name}</option>
                                    )
                                }
                            }
                        })
                        this.setState({classData:classDataList})
                    }
                }
            }
            if(getData2Status===false){
                this.setState({applicationData:null,alertStatus :true, alertType :"error", alertTitle:msg,isLoading:false})
            }
        }

        if(addUserStatus !== prevProps.addUserStatus){
            if(addUserStatus===true){
                /**work on msg */
                this.setState({alertStatus :true, alertType :"success", alertTitle:msg,isSaving:false,btnDisabled:false,modal:false,
               
                })
                if(parseInt(goNext)===1){
                    this.setState({ step1:true,step2:false,step3:false})
                }
                if(parseInt(goNext)===2){
                    this.setState({ step1:false,step2:true,step3:false})
                }
                if(parseInt(goNext)===3){
                    this.setState({ step1:false,step2:false,step3:true})
                }
                if(parseInt(goNext)===4){
                    this.setState({ step1:false,step2:false,step3:false,applicationStatus:1})
                }

                this.props.getMainData("STAFFREGDATA")
            }else if(addUserStatus===false){
                this.setState({alertStatus :true, alertType :"error", alertTitle:msg,isSaving:false,btnDisabled:false,modal:false})
            }
        } 
    }

    render() {
    
        return (
            <div>
                <ReactJsAlert autoCloseIn ={600000} status={this.state.alertStatus} type={this.state.alertType} title={this.state.alertTitle} Close={() => this.setState({ alertStatus: false })}/>
                <div className="">
                {this.state.modal ? 
                    <Modal  isOpen={this.state.modal} className="modalWrapper modal-dialog modal-lg">
                    
                      <ModalBody className="modalBodyWrapper">
                        <Row>
                          <div className="col-xl-12 col-md-12 mb-12 text-center welcomeNote">
                          

                            <h2>St Johns' SS Nandere</h2>
                            <p>Version : {process.env.REACT_APP_VERSION}</p>
                            <p>Contact Us : +256772665527,+256704596102,<br/> <span className='welemail'>stjohnsnandere@gmail.com</span></p>
                            <p><span> &copy; Developed & Maintained By <a href="https://mutanik.com" target="_blank" rel="noopener noreferrer">Mutanik Technologies(U) Ltd</a></span></p>
                          </div>
                        </Row>
                        <ModalFooter>
                          <Button onClick={this.closeModal} className="btn btn-block btn-lg btn-success">Okay</Button>

                        </ModalFooter>
                      </ModalBody>
                          
                  </Modal>: null}


                    <div className="block-header">
                    <h4 className='ccHead'>STUDENT APPLICATION</h4>
                    </div>
                
                    <Row className="mainWrraper">
                        <div className="col-xl-6 col-md-6 mb-6">
                            <div className="card border-left-primary shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                <div className="col mr-2">
                                    <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">Add New Application</div>
                                    <div className="h5 mb-0 font-weight-bold text-gray-800"><Link to="addApplication" className="btn btn-primary">Add New Application</Link></div>
                                </div>
                                <div className="col-auto">
                                    <i className="fas fa-users fa-2x text-gray-300"></i>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        
                        <div className="col-xl-6 col-md-6 mb-6 smallDev">
                            <div className="card border-left-success shadow h-100 py-2 ">
                                <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                    <div className="text-xs font-weight-bold text-success text-uppercase mb-1">Check/Resume Application(s)</div>
                                    <div className="h5 mb-0 font-weight-bold text-gray-800"><Link to="seeApplication" className="btn btn-success">Check/Resume Application(s)</Link></div>
                                    </div>
                                    <div className="col-auto">
                                    <i className="fas fa-eye fa-2x text-gray-300"></i>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </Row>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state =>({
    mainDataStatus : state.mainReducer.dataStatus,
    msg : state.mainReducer.msg,
    mainData : state.mainReducer.mainData,
    addUserStatus:state.mainReducer.addUserStatus,
    getData2Status:state.mainReducer.getData2Status,
    getData2:state.mainReducer.getData2,
});
export default connect(
    mapStateToProps, {getMainData,addUser,restUser,getmyData2}
)(Dashboard)
